import React from 'react';
import Router from './routes';
// theme
import ThemeConfig from './theme';
import NotistackProvider from './components/NotistackProvider';
import LoadingScreen, { ProgressBarStyle } from './components/LoadingScreen';
// hooks
import useAuth from './hooks/useAuth';

function App() {
  const { isInitialized } = useAuth();
  return (
    <ThemeConfig>
      <NotistackProvider>
        <ProgressBarStyle />
        {isInitialized ? <Router /> : <LoadingScreen />}
      </NotistackProvider>
    </ThemeConfig>
  );
}
export default App;